// import React from "react";
// import { Helmet } from "react-helmet";

// // Define SEO content for all pages
// const seoData = {
//   home: {
//     title: "karmyogi Enterprise | Copper Pipes, Fitting, Valve Manufacturer",
//     description: "Karmyogi Enterprise provides premium copper pipes, fittings, and valves.",
//     keywords: "copper pipes, fittings, valves",
//   },
//   about: {
//     title: "About Karmyogi Enterprise | Copper Pipes & Fittings",
//     description: "Learn about Karmyogi Enterprise, a leading supplier of copper pipes, fittings, and valves.",
//     keywords: "Copper pipes, fittings, valves, Karmyogi Enterprise",
//   },
//   contact: {
//     title: "Contact | Karmyogi Enterprise",
//     description: "Get in touch with Karmyogi Enterprise for high-quality copper pipes and fittings.",
//     keywords: "Contact, copper pipes, fittings",
//   },
//   product: {
//     title: "Products | Karmyogi Enterprise",
//     description: "Explore the wide range of premium copper pipes, fittings, and valves offered by Karmyogi Enterprise for all industrial and commercial needs.",
//     keywords: "copper pipes, copper fittings, valves, product catalog, Karmyogi Enterprise",
//   },
//  blog: {
//   title: "Insights & Updates | Karmyogi Enterprise Blog",
//   description: "Stay informed with Karmyogi Enterprises latest news, industry trends, and tips on copper piping, fittings, and HVAC solutions.",
//   keywords: "copper industry news, blog, HVAC tips, Karmyogi Enterprise updates",
// },
//   aluminiumFoliForFins: {
//   title: "Aluminium Foil for Fins | Karmyogi Enterprise",
//   description: "Explore our high-quality aluminium foil designed specifically for heat exchanger fins, ensuring optimal efficiency in HVAC and industrial systems.",
//   keywords: "aluminium foil, heat exchanger fins, HVAC, industrial, Karmyogi Enterprise",
// },
//  brazzingRod: {
//   title: "Brazing Rods for Copper | Karmyogi Enterprise",
//   description: "Premium brazing rods for precise copper jointing, providing strong, leak-proof connections for plumbing, refrigeration, and HVAC applications.",
//   keywords: "brazing rod, copper joint, plumbing, HVAC, Karmyogi Enterprise",
// },
//  cBend: {
//   title: "Copper C Bends | Karmyogi Enterprise",
//   description: "High-quality copper C bends for piping systems, designed for smooth flow and easy installation in plumbing, HVAC, and industrial applications.",
//   keywords: "copper C bends, plumbing, HVAC, piping solutions, Karmyogi Enterprise",
// },
//  copperCap: {
//   title: "Copper Caps | Karmyogi Enterprise",
//   description: "Durable copper caps for sealing pipe ends and protecting systems, crafted for HVAC, plumbing, and industrial piping solutions.",
//   keywords: "copper caps, pipe sealing, HVAC, plumbing, Karmyogi Enterprise",
// },
// copperElbow: {
//   title: "Copper Elbows | Karmyogi Enterprise",
//   description: "Precision-engineered copper elbows for smooth directional changes in piping systems, ideal for plumbing, HVAC, and industrial applications.",
//   keywords: "copper elbows, pipe fitting, plumbing, HVAC, industrial piping, Karmyogi Enterprise",
// },
// copperFilter: {
//   title: "Copper Filters | Karmyogi Enterprise",
//   description: "Durable copper filters designed to efficiently remove impurities and ensure optimal flow in plumbing, gas, and industrial systems.",
//   keywords: "copper filters, water filtration, gas filtration, plumbing, industrial applications, Karmyogi Enterprise",
// },
// copperFoil: {
//   title: "Copper Foil | Karmyogi Enterprise",
//   description: "Premium copper foil for industrial, electrical, and HVAC applications, offering excellent conductivity and durability, available at Karmyogi Enterprise.",
//   keywords: "copper foil, industrial copper sheet, HVAC copper, electrical copper, Karmyogi Enterprise",
// },
// copperPancake: {
//   title: "Copper Pancake Coils | Karmyogi Enterprise",
//   description: "High-quality copper pancake coils, ideal for HVAC, plumbing, and industrial projects, ensuring durability and superior performance at Karmyogi Enterprise.",
//   keywords: "copper pancake, copper coils, HVAC copper, plumbing copper, Karmyogi Enterprise",
// },
// copperStraightPipe: {
//   title: "Copper Straight Pipes | Karmyogi Enterprise",
//   description: "Premium-grade copper straight pipes for plumbing, HVAC, and industrial use, offering reliability and long-lasting performance from Karmyogi Enterprise.",
//   keywords: "copper straight pipe, plumbing copper, HVAC copper pipe, industrial copper pipe, Karmyogi Enterprise",
// },


// };

// const SEO = ({ page }) => {
//   const { title, description, keywords } = seoData[page] || {};

//   return (
//     <Helmet>
//       {title && <title>{title}</title>}
//       {description && <meta name="description" content={description} />}
//       {keywords && <meta name="keywords" content={keywords} />}
//     </Helmet>
//   );
// };

// export default SEO;

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";

const SEO = ({ pageKey }) => {
  const [seoData, setSeoData] = useState({});

  useEffect(() => {
    axios
      // .get(`http://localhost/seo-api/seo.php?pageKey=${pageKey}`)
      .get(`https://karmyogienterprise.com/seo-api/seo.php?pageKey=${pageKey}`)
      .then((res) => setSeoData(res.data))
      .catch((err) => console.log(err));
  }, [pageKey]);

  return (
    <Helmet>
      {seoData.title && <title>{seoData.title}</title>}
      {seoData.description && (
        <meta name="description" content={seoData.description} />
      )}
      {seoData.keywords && (
        <meta name="keywords" content={seoData.keywords} />
      )}
    </Helmet>
  );
};

export default SEO;

